// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"_W-z"};